<template>
  <section class="projects p-relative" id="third">
    <div class="divider">
      <svgDivider fillColor="#20122e"/>
    </div>
    <div class="container grid-xl p-relative">
      <div class="columns">
        <div class="column col-lg-12 col-xl-6 col-6">
          <h1>PROJECTS</h1>
          <p>
            Urna id volutpat lacus laoreet non curabitur gravida arcu ac. Orci ac auctor augue mauris augue. Eget mauris pharetra et ultrices neque ornare. Quam vulputate dignissim suspendisse in est ante in nibh mauris. Elit duis tristique sollicitudin nibh sit.
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column col-xl-12 project_slider">
          <vue-glide
          type="carousel" 
          animationTimingFunc="ease-in-out"
          :gap="0" 
          :animationDuration="2500" 
          :autoplay="true" 
          :perView="4"
          :hoverpause="true" 
          :breakpoints="{
              600: {
                perView: 1
              },
              800: {
                perView: 2
              },
              1000:{
                perView: 3
              }
            }">
            <vue-glide-slide v-for="slide in project" :key="slide.id">
              <a :href="slide.url" target="_blank" class="slide_link">
                <img :src="slide.img" :alt="slide.name" class="slide_link__image">
              </a>
            </vue-glide-slide>
          </vue-glide>
        </div>
      </div>
      <div class="columns">
        <div class="column col-xl-12">
          <Technologies :oneLine="true"/>
        </div>
      </div>
      <topButton :backColor="true"/>
    </div>
  </section>
</template>

<script>
import topButton from './topButton'
import Technologies from './Technologies'
import svgDivider from './svg_icons/svgDivider';
export default {
  name: 'ThirdSection',
  components: {
    topButton,
    Technologies,
    svgDivider
  },
  data(){
    return {
      project: [
        {
          id: 1,
          img: require('../assets/images/project_slider/business.jpg'),
          url: 'http://www.potatosites.com/templates/business/index',
          name: 'Project one',
          description: 'Non enim praesent elementum facilisis. Nisi vitae suscipit tellus mauris a diam maecenas sed. Eget egestas purus viverra accumsan. Arcu cursus vitae congue mauris rhoncus aenean vel elit. Tincidunt arcu non sodales neque sodales ut'
        },
        {
          id: 2,
          img: require('../assets/images/project_slider/cas.jpg'),
          url: 'http://c.potatosites.com',
          name: 'project two',
          description: 'Arcu cursus vitae congue mauris rhoncus aenean vel elit. Tincidunt arcu non sodales neque sodales ut'
        },
        {
          id: 3,
          img: require('../assets/images/project_slider/studio.jpg'),
          url: 'http://studio.potatosites.com',
          name: 'project three',
          description: 'Nulla congue tincidunt aliquam. Duis egestas, tellus tempus interdum pretium, enim neque cursus metus, in accumsan orci quam a eros. Vestibulum vitae efficitur erat, quis volutpat felis.'
        },
        {
          id: 4,
          img: require('../assets/images/project_slider/cross.jpg'),
          url: 'http://www.potatosites.com/templates/cross/index',
          name: 'project four',
          description: 'Maecenas condimentum, eros eget faucibus accumsan, dolor eros faucibus leo, et volutpat purus nibh sit amet enim. Maecenas ut ullamcorper purus'
        },
        {
          id: 5,
          img: require('../assets/images/project_slider/nice.jpg'),
          url: 'http://www.potatosites.com/templates/nice-potato/index',
          name: 'project five',
          description: 'Etiam vehicula arcu lorem, non gravida orci faucibus at. Aliquam erat volutpat. Aliquam suscipit, odio et convallis commodo, augue justo pulvinar velit'
        },
        {
          id: 6,
          img: require('../assets/images/project_slider/pacers.jpg'),
          url: 'http://www.potatosites.com/templates/pacers/index',
          name: 'project six',
          description: 'Phasellus nec risus maximus, efficitur dui scelerisque, iaculis est. Cras ut nibh congue, interdum nulla sit amet, molestie nulla. Sed quis nisi dui. Sed egestas enim sit amet cursus rhoncus'
        },
        {
          id: 7,
          img: require('../assets/images/project_slider/cointheme2.jpg'),
          url: 'http://blog.potatosites.com',
          name: 'project seven',
          description: 'Quisque non tincidunt massa, ullamcorper mollis mauris. Nam a condimentum augue. Nunc feugiat viverra varius'
        },
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.about{
  &__img_cnt{
    padding: 3rem 0;
  }
}
.go_top_btn{
  position: absolute;
  right: 1rem;
  bottom: -75px;
}
.technologies{
  color: $gray-300;
}
.project_slider{
  margin-top: 2rem;
  .glide__slide{
    transition: all 0.2s linear;
  }
}
.slide_link{
  position: relative;
  height: 0;
  padding-bottom: 56.94200351493849%;
  display: block;
  overflow: hidden;
  background-color: lighten($dirty-vel, 15);
  &__image{
    position: absolute;
  }
}
@media screen and (min-width: 961px){
  .a_col_1{
    padding-right: 1rem;
  }
  .a_col_2{
    padding-left: 1rem;
  }
}
</style>
